import React from 'react'
import Navbar from '../components/Navbar'

const BookYours = () => {
  return (
    <div>
      <Navbar/>
    </div>
  )
}

export default BookYours
